import Link from 'next/link';

export default function LegalFooter() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 py-4 px-4">
      {[
        { href: '/agb', label: 'AGB' },
        { href: '/datenschutz', label: 'Datenschutz' },
        { href: '/impressum', label: 'Impressum' },
        { href: '/widerruf', label: 'Widerrufsbelehrung' },
      ]?.map(({ href, label }) => (
        <Link
          key={href}
          href={href}
          className="text-[11px] transition-colors duration-150 hover:underline"
          style={{ color: 'var(--muted-foreground)' }}
        >
          {label}
        </Link>
      ))}
    </div>
  );
}
